export const HOYA_EXTERNAL_LOGIN_URL = 'https://www.hoyavisionhub.com/';

// PROD
export const HOYA_EXTERNAL_MY_ACCOUNT_URL_PROD = 'https://myaccount.hoyavision.com/';
export const SEIKO_EXTERNAL_MY_ACCOUNT_URL_PROD = 'https://myaccount.seikovision.com/';

// PPRD
export const HOYA_EXTERNAL_WAEG_MY_ACCOUNT_URL_PPRD = 'https://uat-hoyaprofilemanagement.appius.co.uk/';
export const SEIKO_EXTERNAL_WAEG_MY_ACCOUNT_URL_PPRD = 'https://uat-seikomyaccount.appius.co.uk/';
